<template>
  <div>
    <div class="content-left">
      <div class="rom-box">
        <Row>
          <Col span="8">
            <Menu @on-select="queryCourseware" accordion>
              <template v-for="act in architectureList">
                <template>
                  <Submenu :name="act.id" :key="act.inner_id" class="clickBgc">
                    <template slot="title">
                      <Icon type="ios-book" />
                      <a>{{act.name}}</a>
                    </template>
                    <template  v-for="at in act.son" >
                      <MenuItem :name="at.columns.id" :key="at.columns.inner_id" class="clickBgc2">
                        <Icon type="md-book"/>
                        <a> {{at.columns.name}}</a>
                      </MenuItem>
                    </template>
                  </Submenu>
                </template>
              </template>
            </Menu>
          </Col>
        </Row>
      </div>
    </div>
    <div class="content-right" v-show="is_show == 1">
      <div class="content-right-box">
        <Table stripe :columns="columns1" :data="coursewarePageList" class="table"></Table>
        <Page :total="totalRow" :page-size="pageSize"  style="text-align:center;margin-top: 15px;margin-bottom: 15px;"
              @on-change="pageNumberChange"  @on-page-size-change='pageSizeChange'  show-sizer show-total/>
      </div>
    </div>
  </div>
</template>

<script>

  import RequestUtil from '../../../utils/RequestUtil';
  import Constants from '../../../common/Constants';
  export default {
    name: "specification",
    data(){
      return{
        id:'',
        current: 0,
        pageSize : this.Constants.pageSize , //每页显示10条数据
        pageNumber : this.Constants.pageCurrent, //当前页码
        totalRow : 0, //总记录数
        totalPage : 0,//总页数
        aid:"",
        columns1: [
          {
            title: this.$t('i.courseware.name'),
            key: 'name'
          },
          // {
            // title: this.$t('i.courseware.orgName'),
            // key: 'orgname'
          // },
          {
            title: this.$t('i.courseware.course_architecture_names'),
            key: 'course_architecture_names'
          },
          {
            title: this.$t('i.courseware.operation'),
            key:'id',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let Selectid = params.row.id;
                      let type = params.row.type;
                      console.log('id',Selectid);
                      this.Courseware(Selectid,type);
                    }
                  }
                }, '閲覧')
              ]);
            }
          }
        ],
        architectureList:[],
        architectureLists:[],
        coursewarePageList:[],
        serverURL:this.Constants.serverURL,
        type:'',
        is_show:'1',
        architectureindex:'',
      }
    },
    methods: {
      //初始化
      async Selectcourseware(){
        this.is_show = '0'
        let architectureid = this.$route.query.architectureindex;
        this.id = this.$route.query.architectureindex;
        console.log("初始化",architectureid);
        let inner_id = this.$route.query.inner_id;
        this.type = this.$route.query.type;
        const json = await RequestUtil.request("/front/courseware/list?pageCurrent=" + this.pageNumber + "&pageSize=" + this.pageSize +"&architecture_inner_id="+inner_id +" &architectureindex="+architectureid);
        if(json){
          if(json.statusCode == Constants.statusCode.ok){
            this.architectureList = json.datas.architectureList;
            this.coursewarePageList = json.datas.coursewarePageList.list;
            this.pageSize = json.datas.coursewarePageList.pageSize;
            this.pageNumber = json.datas.coursewarePageList.pageNumber;
            this.totalRow = json.datas.coursewarePageList.totalRow;
            this.totalPage = json.datas.coursewarePageList.totalPage;
            this.is_show = '0'
          }
        }
      },
      pageNumberChange(value){
        this.pageNumber = value;
        this.queryCourseware(this.architectureindex)
      },
      pageSizeChange(value){
        this.pageSize = value;
        this.queryCourseware(this.architectureindex)
      },
      //点击左侧树刷新右侧
      async queryCourseware(id){
        this.architectureindex = id
        console.log("点击",id);
        const json = await RequestUtil.request("/front/courseware/list?flag=1&architectureindex="+id + "&pageCurrent=" + this.pageNumber + "&pageSize=" + this.pageSize);
        if(json){
          if(json.statusCode == Constants.statusCode.ok){
            this.coursewarePageList = json.datas.coursewarePageList.list;
            this.pageSize = json.datas.coursewarePageList.pageSize;
            this.pageNumber = json.datas.coursewarePageList.pageNumber;
            this.totalRow = json.datas.coursewarePageList.totalRow;
            this.totalPage = json.datas.coursewarePageList.totalPage;
            // console.log(this.coursewarePageList)
            this.is_show = '1'
          }
        }
      },
      getName(index){
        const name = index;
        return name;
      },
      getName2(index){
        let count = 3000;
        const name = parseInt(Math.random()*count);
        return name;
      },
      //点击查看按钮(预览)
      async Courseware(Selectid,type){
        const curJsSessionId = localStorage.getItem("curJsSessionId");

        if(this.Constants.studyCourseFlag == -1){
          this.Constants.studyCourseFlag = setInterval(function(){
            let url = "/requestSes?_="+new Date().getTime() + "&curJsSessionId="+curJsSessionId;
            RequestUtil.request(url);
          },1000*60*25);//25分钟执行一次
        }

        let open_url = "";
        if("1"==type){
          open_url = this.serverURL + "/resource/courseware/previewCourseware?id="+Selectid + "&type=" + type + "&flag=front";
        }else if("2"==type){
          open_url = this.serverURL + "/resource/courseware/studyVideo?courseId="+Selectid + "&flag=front";
        }
        open_url += "&curJsSessionId=" + curJsSessionId +"&language="+localStorage.getItem("defaultLangValue");
        window.open(open_url);
      },
      async flashData(){
        this.queryCourseware(this.id)
      }
    },
    created() {
      this.Selectcourseware();
    }
  }
</script>

<style scoped>
  .content-left{
    width: 240px;
    position: relative;
    float: left;
    margin-right: 30px;
  }
  .clickBgc{
    /*公司金融0和技术*/
    background-color: #efefef;
    margin-bottom: 2px;
  }
  .clickBgc2{
    /*公司金融0和技术下拉*/
    background-color: #cccaca;
    margin-bottom: 2px;
  }
  .clickBgc3{
    /*公司金融1和公司金融2*/
    background-color: #efefef;
    margin-bottom: 2px;
  }
  /*.clickBgc1 > .ivu-menu-light.ivu-menu-vertical,*/
  /*.ivu-menu-item-active:not(.ivu-menu-submenu){*/
    /*!*点击的效果*!*/
    /*background-color: red!important;*/
  /*}*/
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    /*侧边条的颜色*/
    background: #f0faff;
  }
  .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #2d8cf0;
  }
  /*.ivu-menu-vertical .ivu-menu-item:hover,*/
  /*.ivu-menu-vertical .ivu-menu-submenu-title:hover {*/
    /*color: #2d8cf0;*/
  /*}*/
  .content-left a{
    color: #000;
  }
  .rom-box a:hover{
    color: #2d8cf0;
  }
  .content-right{
    width: 762px;
    min-height: 575px;
    float: right;
    border-radius: 10px;
    border: 1px solid #ababab;
  }
</style>



// WEBPACK FOOTER //
// src/pages/study/components/specification.vue